// extracted by mini-css-extract-plugin
module.exports = {"Container":"SuccessScreen_Container__36ree","Countdown":"SuccessScreen_Countdown__2QJJS"};